import React from "react";

const OpenseaEmbed = ({
  contractAddress,
  nftId,
}: {
  contractAddress: string;
  nftId: string;
}) => {
  return (
    <div style={{ position: "absolute", top: "30%", right: "30%" }}>
      <div
        dangerouslySetInnerHTML={{
          __html: `<nft-card
    contractAddress="${contractAddress}"
    tokenId="${nftId}">
    </nft-card>`,
        }}
      ></div>
    </div>
  );
};

export default OpenseaEmbed;
